

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Question = _interopRequireDefault(require("./Question"));

var _Answer = _interopRequireDefault(require("./Answer"));

var _Result = _interopRequireDefault(require("./Result"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Quiz =
/*#__PURE__*/
function (_Component) {
  _inherits(Quiz, _Component);

  function Quiz(props) {
    var _this;

    _classCallCheck(this, Quiz);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Quiz).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (index) {
      console.log(index);
      var _this$state = _this.state,
          step = _this$state.step,
          questions = _this$state.questions,
          answers = _this$state.answers,
          totalQuestions = _this$state.totalQuestions;
      answers.push(index + 1);
      var updatedStep = step;

      if (step < totalQuestions - 1) {
        updatedStep = step + 1;

        _this.setState({
          step: updatedStep,
          currentQuestion: questions[updatedStep]
        });
      } else {
        _this.setState({
          endQuiz: true
        });
      }
    });

    var quiz = _this.props.quiz;
    _this.state = {
      step: 0,
      title: quiz.quizTitle,
      questions: quiz.questions,
      currentQuestion: quiz.questions[0],
      answers: [],
      correctAns: [],
      totalQuestions: quiz.questions.length,
      endQuiz: false,
      showResult: false
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.parseCorrectAnswer();

    return _this;
  }

  _createClass(Quiz, [{
    key: "parseCorrectAnswer",
    value: function parseCorrectAnswer() {
      var _this$state2 = this.state,
          correctAns = _this$state2.correctAns,
          questions = _this$state2.questions;
      questions.map(function (question) {
        return correctAns.push(question.correctAnswer);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          title = _this$state3.title,
          questions = _this$state3.questions,
          currentQuestion = _this$state3.currentQuestion,
          answers = _this$state3.answers,
          correctAns = _this$state3.correctAns,
          endQuiz = _this$state3.endQuiz;
      return _react.default.createElement("div", {
        className: "react-quiz-container"
      }, _react.default.createElement("h2", null, title), endQuiz === true ? _react.default.createElement(_Result.default, {
        questions: questions,
        answers: answers,
        correctAns: correctAns
      }) : _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-12 col"
      }, _react.default.createElement("h3", {
        className: "questionCount"
      }, `${this.state.step+1} / 25`), _react.default.createElement(_Question.default, {
        currentQuestion: currentQuestion
      }))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-12 col"
      }, _react.default.createElement(_Answer.default, {
        questionType: currentQuestion.questionType,
        answers: currentQuestion.answers,
        handleClick: this.handleClick,
        renderInResult: false
      })))));
    }
  }]);

  return Quiz;
}(_react.Component);

Quiz.propTypes = {
  quiz: _propTypes.default.object
};
var _default = Quiz;
exports.default = _default;